$(document).ready(function(){
    //自動カナ入力
    $.fn.autoKana('.form-name1', '.form-kana1', {katakana:true});
    $.fn.autoKana('.form-name2', '.form-kana2', {katakana:true});
});